import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
  margin: 0;
`;

export const Breadcrumbs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.gray500};

  span {
    color: ${({ theme }) => theme.colors.gray900};
    font-weight: 500;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  padding: 40px;
  display: flex;
  justify-content: space-between;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 24px;
    gap: 32px;
  }
`;

export const DescriptionSection = styled.div`
  flex: 0 0 300px;

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
  }
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray900};
  margin: 0;
`;

export const SectionText = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.gray600};
  margin: 0;
  line-height: 1.5;
`;

export const FormSection = styled.div`
  flex: 1;
  max-width: 600px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

export const EyeButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};
  padding: 0;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;
